import { useContracts } from 'api/company/useContracts'
import { MainPage } from 'components/templates/MainPage'

export const ContractsPage = (): JSX.Element => {
  const { data } = useContracts()

  return (
    <MainPage>
      <div className={'space-y-5'}>
        <section
          className={'grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4'}
        >
          <div className={'rounded-md border bg-white p-4 shadow-sm'}>
            <p className={'text-xs text-gray-500'}>稼働中契約</p>
            <p className={'mt-1 text-2xl font-bold text-gray-800'}>
              {data?.summary.activeContracts}
            </p>
          </div>
          <div className={'rounded-md border bg-white p-4 shadow-sm'}>
            <p className={'text-xs text-gray-500'}>月額総額</p>
            <p className={'mt-1 text-2xl font-bold text-gray-800'}>
              {data?.summary.monthlySales}
            </p>
          </div>
          <div className={'rounded-md border bg-white p-4 shadow-sm'}>
            <p className={'text-xs text-gray-500'}>月額粗利</p>
            <p className={'mt-1 text-2xl font-bold text-gray-800'}>
              {data?.summary.monthlyProfit}
            </p>
          </div>
          <div className={'rounded-md border bg-white p-4 shadow-sm'}>
            <p className={'text-xs text-gray-500'}>更新予定（3ヶ月以内）</p>
            <p className={'mt-1 text-2xl font-bold text-gray-800'}>
              {data?.summary.renewalSoon}
            </p>
          </div>
        </section>

        <section className={'space-y-3'}>
          {data?.contracts.map((contract) => {
            const statusClass =
              contract.status === '更新予定'
                ? 'bg-amber-50 text-amber-700'
                : contract.status === '稼働中'
                  ? 'bg-emerald-50 text-emerald-700'
                  : 'bg-blue-50 text-blue-700'

            return (
              <article
                key={contract.id}
                className={'rounded-md border bg-white p-4 shadow-sm'}
              >
                <div
                  className={
                    'flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between'
                  }
                >
                  <div>
                    <h2 className={'text-base font-bold text-gray-800'}>
                      {contract.companyName}
                    </h2>
                    <p className={'text-xs text-gray-500'}>
                      {contract.contractType}
                    </p>
                    <p className={'text-xs text-gray-500'}>{contract.period}</p>
                  </div>

                  <div className={'grid grid-cols-2 gap-2 xl:grid-cols-4'}>
                    <div className={'rounded bg-gray-50 p-2 text-center'}>
                      <p className={'text-xs text-gray-500'}>月額単価</p>
                      <p className={'text-sm font-bold text-gray-800'}>
                        {contract.unitPrice}
                      </p>
                    </div>
                    <div className={'rounded bg-gray-50 p-2 text-center'}>
                      <p className={'text-xs text-gray-500'}>月額粗利</p>
                      <p className={'text-sm font-bold text-gray-800'}>
                        {contract.grossProfit}
                      </p>
                    </div>
                    <div className={'rounded bg-gray-50 p-2 text-center'}>
                      <p className={'text-xs text-gray-500'}>稼働要員</p>
                      <p className={'text-sm font-bold text-gray-800'}>
                        {contract.members}名
                      </p>
                    </div>
                    <div className={'rounded bg-gray-50 p-2 text-center'}>
                      <p className={'text-xs text-gray-500'}>担当営業</p>
                      <p className={'text-sm font-bold text-gray-800'}>
                        {contract.owner}
                      </p>
                    </div>
                  </div>

                  <span
                    className={`self-start rounded-full px-3 py-1 text-xs font-semibold ${statusClass}`}
                  >
                    {contract.status}
                  </span>
                </div>
              </article>
            )
          })}
        </section>
      </div>
    </MainPage>
  )
}
